import React, { useEffect, useState } from "react";
import Navbar from "../Navbar/Navbar";
import "./Gem.css"
import { getCompletedGemBidList, getCustomerList } from "../../Redux/Gem/Action";
import { useDispatch, useSelector } from "react-redux";
import NewDataTable from "../DataTable/NewDataTable";
import { endOfMonth, format, startOfMonth } from "date-fns";
import { FaEye } from "react-icons/fa6";
import DatePicker from "react-datepicker";

const GemCompletedList = () => {

    const dispatch = useDispatch();
    const token = localStorage.getItem("token");
    const loginId = localStorage.getItem("loginId");
    const { completedGemBidList } = useSelector((store) => store.gem);
    const [showRemakrs, setShowRemakrs] = useState(false);
    const [fromDate, setFromDate] = useState(startOfMonth(new Date()));
    const [toDate, setToDate] = useState(endOfMonth(new Date()));

    const [bidDetails, setBidDetails] = useState({
        bidNumber: "",
        bidTitle: "",
        customerName: "",
        contactPerson: "",
        contactAddress: "",
        preBid: "",
        preBidDate: "",
        status: "",
        startDate: "",
        endDate: "",
        remarks: "",
        gemFileLink: "",
    })

    useEffect(() => {
        const formattedFromDate = format(fromDate, "yyyy-MM-dd");
        const formattedToDate = format(toDate, "yyyy-MM-dd");
        dispatch(getCompletedGemBidList(formattedFromDate, formattedToDate, token));
        dispatch(getCustomerList(token));
    }, [dispatch, token, loginId, fromDate, toDate]);

    const Tooltip = ({ text, children }) => {
        return (
            <div className="tooltip-container">
                {children}
                <div className="tooltip">{text}</div>
            </div>
        );
    };


    const handleRemakrsClick = (row) => {
        setBidDetails({
            bidNumber: row?.bidNumber || "-",
            bidTitle: row?.bidTitle || "-",
            customerName: row?.customerName || "-",
            contactPerson: row?.contactPerson || "-",
            contactAddress: row?.contactAddress || "-",
            preBid: row?.preBid || "-",
            preBidDate: row?.preBidDate || "-",
            status: row?.status || "-",
            startDate: row?.startDate || "-",
            endDate: row?.endDate || "-",
            remarks: row?.remarks || "-",
            gemFileLink: row?.gemFileLink || null,
        })
        setShowRemakrs(true);
    }


    const columns = [
        {
            name: "SN",
            cell: (_, index) => index + 1,
            sortable: false,
            width: "80px",
            align: "center",
        },
        {
            name: "Bid Number",
            selector: (row) => row?.bidNumber || "-",
            sortable: true,
            align: "left",
        },
        {
            name: "Bid Title",
            selector: (row) => row?.bidTitle || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "End Date",
            cell: (row) => {
                if (!row.endDate) return "-";

                const date = format(new Date(row.endDate), "dd-MM-yyyy");
                const time = format(new Date(row.endDate), "HH:mm a");

                return (
                    <div style={{ whiteSpace: "pre-line", textAlign: "center" }}>
                        {`${date}\n${time}`}
                    </div>
                );
            },
            sortable: true,
            align: "center",
        },
        {
            name: "Customer Name",
            selector: (row) => row?.customerName ?? "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Contact Address",
            selector: (row) => row?.contactAddress || "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Pre Bid",
            selector: (row) => row?.preBid ?? "-",
            sortable: true,
            align: "center",
        },
        {
            name: "Pre Bid Date",
            selector: (row) => {
                if (!row?.preBidDate) return "-";
                return format(new Date(row.preBidDate), "dd-MM-yyyy");
            },
            sortable: true,
            align: "center",
        },
        {
            name: "Action",
            selector: (row) => row,
            sortable: false,
            align: "center",
            cell: (row) => (
                <>
                    <Tooltip text="Preview">
                        <button type="button" className="btn btn-secondary btn-sm" onClick={() => handleRemakrsClick(row)}>
                            <FaEye size={12} />
                        </button>

                    </Tooltip>
                </>

            ),

        },
    ];


    return (
        <div>
            <Navbar />

            <div className="main-content">
                <div className="container-fluid mt-4">
                    <div className="row mb-3">
                        <div className="col-12 d-flex justify-content-md-end">
                            <div className="filter-row d-flex flex-wrap">
                                <div className="filter-item d-flex align-items-center">
                                    <b><label className="custom-label me-1">From:</label></b>
                                    <div className="field-width">
                                        <DatePicker
                                            selected={fromDate}
                                            onChange={(v) => setFromDate(v)}
                                            className="form-control"
                                            dateFormat="dd-MM-yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            dropdownMode="select"
                                            onKeyDown={(e) => e.preventDefault()}
                                        />
                                    </div>
                                </div>

                                <div className="filter-item d-flex align-items-center">
                                    <b><label className="custom-label me-1">To:</label></b>
                                    <div className="field-width">
                                        <DatePicker
                                            selected={toDate}
                                            onChange={(v) => setToDate(v)}
                                            className="form-control"
                                            dateFormat="dd-MM-yyyy"
                                            showYearDropdown
                                            showMonthDropdown
                                            dropdownMode="select"
                                            onKeyDown={(e) => e.preventDefault()}
                                            minDate={fromDate}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="card3">
                        <div className="card-body">
                            <NewDataTable
                                columns={columns}
                                data={completedGemBidList || []}
                                tableName="GeM COMPLETED LIST"
                                totalRecord={completedGemBidList?.length ?? 0}
                            />
                        </div>
                    </div>
                </div>
            </div>

            {showRemakrs && (
                <div
                    className="modal fade leave-modal show"
                    tabIndex="-1"
                    style={{
                        display: "block",
                        backgroundColor: "rgba(0,0,0,0.5)",
                    }}
                >
                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Bid Details</h5>
                                <button
                                    type="button"
                                    className="btn-close"
                                    onClick={() => setShowRemakrs(false)}
                                ></button>
                            </div>
                            <div className="modal-body">
                                <div className="bid-details-container">
                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <h6 className="fw-bold">Bid Number:</h6>
                                            <p>{bidDetails.bidNumber || "-"}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <h6 className="fw-bold">Start Date:</h6>
                                            <p>{bidDetails.startDate
                                                ? format(new Date(bidDetails.startDate), "dd-MM-yyyy  hh:mm a")
                                                : "-"}
                                            </p>
                                        </div>
                                        <div className="col-md-4">
                                            <h6 className="fw-bold">End Date:</h6>
                                            <p>{bidDetails.endDate
                                                ? format(new Date(bidDetails.endDate), "dd-MM-yyyy  hh:mm a")
                                                : "-"}</p>
                                        </div>

                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <h6 className="fw-bold">Bid Title:</h6>
                                            <p>{bidDetails.bidTitle || "-"}</p>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <h6 className="fw-bold">Customer Name:</h6>
                                            <p>{bidDetails.customerName || "-"}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <h6 className="fw-bold">Contact Person:</h6>
                                            <p>{bidDetails.contactPerson || "-"}</p>
                                        </div>
                                        <div className="col-md-4">
                                            <h6 className="fw-bold">Contact Address:</h6>
                                            <p>{bidDetails.contactAddress || "-"}</p>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-4">
                                            <h6 className="fw-bold">Pre Bid:</h6>
                                            <p>{bidDetails.preBid || "-"}</p>
                                        </div>
                                        {bidDetails.preBid === "Yes" && (
                                            <div className="col-md-4">
                                                <h6 className="fw-bold">Pre-Bid Date:</h6>
                                                <p>
                                                    {bidDetails.preBidDate
                                                        ? format(new Date(bidDetails.preBidDate), "dd-MM-yyyy")
                                                        : "-"}
                                                </p>
                                            </div>
                                        )}
                                        <div className={`${bidDetails.preBid === "Yes" ? "col-md-4" : " col-md-8"}`}>
                                            <h6 className="fw-bold">GeM File:</h6>
                                            <p> {bidDetails.gemFileLink ? (<a href={bidDetails.gemFileLink} target="_blank" className="" > {bidDetails.gemFileLink} </a>) : ("-")} </p>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-md-12">
                                            <h6 className="fw-bold">Remarks:</h6>
                                            <p>{bidDetails.remarks || "No Remarks"}</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>

    );

};

export default GemCompletedList;
